import _ from 'underscore';

export function join(first: string, ...frags: Array<string | null | undefined>) {
  return frags.reduce((memo, frag) => {
    if (_.isEmpty(frag)) {
      return memo;
    }
    const eSlash = /\/$/.test(memo);
    const sSlash = /^\//.test(frag as string);

    if (!eSlash && !sSlash) {
      return `${memo}/${frag}`;
    }
    if (eSlash && sSlash) {
      return memo + (frag as string).substring(1);
    }
    return memo + frag;
  }, first);
}
